export default __webpack_public_path__ + "static/media/featured8.png";